module.exports = __webpack_public_path__ + "static/full03-c286431b8850286d300aac73e83de615.png";